export const palette = {
  bg: '#191d1f',
  surface: '#282d2f',
  surfaceElev: '#353a3c',
  border: '#454b4d',
  text: '#e5e7eb',
  textMuted: '#cbd5e1',
  neutral: '#94a3b8',
  indigo: '#3c57a8',
  cyan: '#00a8f0',
  yellow: '#e69b0d',
  red: '#e23846',
} as const;

export const seriesColors = [palette.cyan, palette.indigo] as const;

export const categoryAccent: Record<string, string> = {
  'session-performance': palette.indigo,
  utilization: palette.cyan,
  wellness: palette.red,
  'system-performance': palette.yellow,
};

export const radii = {
  lg: '12px',
  md: '8px',
  sm: '6px',
} as const;

export const shadows = {
  sm: '0 1px 2px 0 rgba(0,0,0,0.05)',
  md: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1)',
} as const;

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
} as const;

export const cardStyles =
  'rounded-lg border border-[var(--anl-border)] bg-[var(--anl-surface)] text-[var(--anl-text)] shadow-md';

export const ACCENT_HEIGHT_PX = 6;
